import * as React from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";

export default function CvEugeni() {
  return (
    <>
      <Layout
        title="CV Eugeni Prieto"
        description="Currículum Vitae d'Eugeni Prieto"
        path="cv-eugeni-prieto"
      >
        <>
          <h2 className="textHeading">Eugeni Prieto</h2>
          <h3 className="textHeading">A manera de currículum</h3>
          <p className="textParagraph">
            Neixo a Tortosa l’any 1950. Actualment visc a Jafre (Empordà).
          </p>
          <p className="textParagraph">
            Fa més de 30 anys que coordino i organitzo exposicions artístiques.
          </p>
          <p className="textParagraph">
            De formació autodidàctica, començo fent fotografia de carrer als
            anys 70. Sempre m’hi ha interessat el retrat i el nu (que no deixa
            de ser una prolongació d’aquell).
          </p>
          <p className="textParagraph">
            Començo a exposar públicament a partir de l’any 2015.
          </p>
          <p className="textParagraph">
            <span>2015</span>
          </p>
          <p className="textParagraph">
            <span>Setembre.</span> Exposo públicament, per primer cop, un
            conjunt de retrats d'artistes al Museu de la Mediterrània amb el
            títol de “A-10”, amb el qual poso fi a la meva col·laboració amb
            aquest Museu.
          </p>
          <p className="textParagraph">
            <span>Desembre.</span> Participació en l’exposició fotogràfica
            “Paisatge i racons de l’Albera” amb dues obres.
          </p>
          <p className="textParagraph">
            <span>2016</span>
          </p>
          <p className="textParagraph">
            <span>Gener.</span> Inauguro exposició de retrats d'artistes al
            Palau Solterra (Fundació Vila Casas) de Torroella de Montgrí. “Punt
            de vista”.
          </p>
          <p className="textParagraph">
            <span>Juliol.</span> Exposició a La Sala de Torroella de Montgrí
            d’un conjunt d’autoretrats en la presentació pública de BUIT
            (grumolls de cultura contemporània), del que formo part.
          </p>
          <p className="textParagraph">
            <span>Setembre.</span> Exposició de retrats d’artistes a la casa de
            cultura Les Bernardes de Salt. “Empremtes”
          </p>
          <p className="textParagraph">
            <span>Desembre.</span> “Reversible”. Presentació de les imatges que
            formen part del llibre amb poesia de la Rosa Pou, del mateix títol,
            a la llibreria Vitel.la de L’Escala.
          </p>
          <p className="textParagraph">
            <span>2017</span>
          </p>
          <p className="textParagraph">
            Presentacions del llibre a l’Espai Tònic de La Bisbal, a La Sala de
            Torroella de Montgrí i a la llibreria 22 de Girona. Participació a
            la II Fira de Fotografía, a Torroella de Montgrí (abril).
          </p>
          <p className="textParagraph">
            <span>2018</span>
          </p>
          <p className="textParagraph">
            <span>Març.</span> Presentació del llibre i exposició de fotografies
            a Pèrgam llibres, Barcelona.
          </p>
          <p className="textParagraph">
            <span>Abril.</span> Exposició i presentació del llibre a
            Mediterrània, Espai Forum de Palafrugell.
          </p>
          <p className="textParagraph">
            <span>2019</span>
          </p>
          <p className="textParagraph">
            <span>Gener.</span> Exposició col.lectiva, a La Mercè de Girona,
            dintre de la 12 edició del festival d’art independent Pepe Sales.
            Abril. “Geografia i paisatge” a la Galeria fotogràfica Tres-e-u de
            Vic. Juny. Inund’ART a Girona. Fundació Fita. Casa de Cultura
            Setembre. Col.lectiva “Músics & Música” Galeria Tres-e-u de Vic.
          </p>
          <p className="textParagraph">
            <span>2020</span>
          </p>
          <p className="textParagraph">
            Al maig publico el llibre de retrats, autoeditat en col.laboració
            amb Duaita Prats, “79 ànimes d’artista en l’univers gironí” ; el
            presentarem publicament a la Casa de Cultura de Girona el juliol,
            mes en que també participo en la col.lectiva “23 espines” que
            s’exposa a la Fundació Valvi, de Girona.{" "}
          </p>
          <p className="textParagraph">
            <span>Setembre.</span> Participació en la col.lectiva
            “Fotoconfinades” a la galeria 3e1 de Vic.
          </p>
          <p className="textParagraph">
            Obres en col.leccions particulars i en la Fundació Vila-Casas.
          </p>
          <p className="textParagraph">
            <span>2021</span>
          </p>
          <p className="textParagraph">
            “Ànimes d’artistes en l’univers gironí”, exposició a Fotofília Vic
            (Barcelona)
          </p>
          <p className="textParagraph">
            <span>2022</span>
          </p>
          <p className="textParagraph">
            <span>Abril.</span> Amb Pau Guerrero exposició “Cos- Paisatge” al
            Centre Experimental de les Arts de Vallgrassa (Barcelona).
          </p>
          <p className="textParagraph">
            <span>Abril.</span> ”Correlats” (col.lectiva homenatje a Gabriel
            Ferrater) a la Capella de Sant Antoni de Torroella de
            Montgrí(Girona)
          </p>
          <p className="textParagraph">
            <span>Juny.</span> “Correlats” a la Llibreia Vitel.la Espai Fòrum de
            Palafrugell (Girona)
          </p>
          <p className="textParagraph">
            <span>Agost.</span> Amb Pau Guerrero “Cos-Paisatge” al Museu de la
            Mediterrània de Torroella de Montgrí (Girona)
          </p>
          <p className="textParagraph">
            <span>Novembre.</span> Amb Pau Guerrero, “Cos-Paisatge” a la Galeria
            3e1 de Vic (Barcelona)
          </p>
          <p className="textParagraph">
            Obres en col.leccions particulars i en la Fundació Vila-Casas
          </p>

          <div className="textLinks">
            <div className="textLink">
              <Link to="/eugeni-prieto-text">Tornar</Link>
            </div>
          </div>
        </>
      </Layout>
    </>
  );
}
